<template>
    <v-dialog v-model="abrir" scrollable>
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon @click.native="abrir = false" dark>
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ (oper === 'edit')? 'Editar' : 'Agregar' }} Cliente</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <form @submit.prevent="agregar()">
                    <v-container grid-list-md>
                        <v-layout row wrap>
                            <v-flex xs4>
                                <v-text-field v-model="a.cuit" label="CUIT" mask="##-########-#" :loading="loadingCuit"
                                              :error-messages="errores.collect('cuit')"
                                              v-validate="'required|validar_cuit'"
                                              data-vv-name="cuit"
                                ></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field v-model="a.rzon_soc" label="Razón social"
                                              :error-messages="errores.collect('rzon_soc')"
                                              v-validate="'required'"
                                              data-vv-name="rzon_soc"
                                ></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field v-model="a.tel" label="Teléfono"
                                              :error-messages="errores.collect('tel')"
                                              v-validate="'required'"
                                              data-vv-name="tel"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                <v-text-field v-model="a.dir" label="Dirección"></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field v-model="a.email" label="E-Mail"></v-text-field>
                            </v-flex>
                            <v-flex>
                                <provincia-select v-model="a.provincia_id"></provincia-select>
                            </v-flex>
                            <v-flex>
                                <pais-select v-model="a.pais_id"></pais-select>
                            </v-flex>
                        </v-layout>
                        <h4>Contactos</h4>
                        <v-layout>
                            <v-flex>
                                <v-select label="Tipo" v-model="contacto_tipo" :items="contactoTipos" return-object
                                          item-text="desig" item-value="id"
                                ></v-select>
                            </v-flex>
                            <v-flex>
                                <v-text-field v-model="cont.nom" label="Nombre"></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field v-model="cont.tel1" label="Telefono 1"></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field v-model="cont.tel2" label="Telefono 2"></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field v-model="cont.email" label="Email"></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field v-model="cont.dir" label="Dirección"></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-btn icon dark color="green" @click.native="contactoNuevo()">
                                    <v-icon>add</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                        <v-data-table
                                :headers="headers"
                                :items="contactos"
                                hide-actions
                        >
                            <template slot="items" slot-scope="props">
                                <td class="text-xs-center">{{ props.item.tipo.desig }}</td>
                                <td class="text-xs-center">{{ props.item.nom }}</td>
                                <td class="text-xs-center">{{ props.item.tel1 }}</td>
                                <td class="text-xs-center">{{ props.item.tel2 }}</td>
                                <td class="text-xs-center">{{ props.item.email }}</td>
                                <td class="text-xs-center">{{ props.item.dir }}</td>
                                <td class="text-xs-center">
                                    <v-btn flat icon dark color="red" small @click.native="contactoElim(props.item)">
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </td>
                            </template>
                        </v-data-table>
                    </v-container>
                </form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" :loading="loading" flat @click.native="guardar">Confirmar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import mixinCliente from '../mixins/cliente';
    import {mapActions} from 'vuex';
    import provinciaSelect from '../components/ProvinciaSelect';
    import paisSelect from '../components/PaisSelect';

    function getInitialDataContacto() {
        return {
            nom: '',
            tel1: '',
            tel2: '',
            email: '',
            dir: '',
            contacto_tipo_id: '',
            tipo: {}
        }
    }

    function getInitialDataCliente() {
        return {
            cuit: '',
            rzon_soc: '',
            email: '',
            dir: '',
            tel: '',
            provincia_id: '',
            pais_id: ''
        }
    }

    export default {
        name: "modal-cliente",
        props: ['value', 'datos', 'oper', 'cliente'],
        mixins: [mixinCliente],
        components: {paisSelect, provinciaSelect},
        $_veeValidate: {
            validator: 'new'
        },
        data() {
            return {
                loading: false,
                loadingCuit: false,
                headers: [
                    {text: 'Tipo', value: 'contacto_tipo_id', align: 'center'},
                    {text: 'Nombre', value: 'nom', align: 'center'},
                    {text: 'Tel 1', value: 'tel1', align: 'center'},
                    {text: 'Tel 2', value: 'tel2', align: 'center'},
                    {text: 'Email', value: 'email', align: 'center'},
                    {text: 'Dir', value: 'dir', align: 'center'},
                    {text: 'Oper', value: '', align: 'center'},
                ],
                a: getInitialDataCliente(),
                cont: getInitialDataContacto(),
                contactos: [],
                contactoTipos: []
            }
        },
        computed: {
            abrir: {
                get() {
                    return this.value;
                },
                set(valor) {
                    this.$emit('input', valor)
                }
            },
            contacto_tipo: {
                get() {
                    return this.cont.contacto_tipo_id;
                },
                set(valor) {
                    this.cont.contacto_tipo_id = valor.id;
                    this.cont.tipo = valor;
                }
            }
        },
        watch: {
            value() {
                if (this.oper !== 'edit' && this.value) {
                    this.limpiar();
                }
                if (this.oper === 'edit' && this.value) {
                    this.limpiar();
                    this.clienteShow(this.cliente, r => {
                        this.a = r;
                        this.contactos = r.contactos;
                    }, err => {
                        console.log(err);
                    })
                }
            }
        },
        mounted() {
            this.clienteContactoTipos(r => {
                this.contactoTipos = r;
            }, err => console.log(err))
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            contactoNuevo() {
                this.contactos.push(this.cont);
                this.cont = getInitialDataContacto();
            },
            contactoElim(item) {
                const index = this.contactos.indexOf(item);
                this.contactos.splice(index, 1);
            },
            guardar() {
                this.$validator.validateAll()
                    .then(r => {
                        if (!r) {
                            return false;
                        }
                        this.loading = true;
                        if (this.oper === 'edit') {
                            this.clienteUpdate(this.a.id, {cliente: this.a, contactos: this.contactos}, r => {
                                this.msjShow(r)
                                this.$emit('update:datos', r.d);
                                this.abrir = false;
                                this.loading = false;
                            }, err => {
                                if (err.errors) {
                                    this.msjShow({txt: 'Error', tipo: 'error', errores: err.errors});
                                }
                                this.loading = false;
                            })
                        } else {
                            this.clienteStore({cliente: this.a, contactos: this.contactos}, r => {
                                this.msjShow(r)
                                this.$emit('update:datos', r.d);
                                this.abrir = false;
                                this.loading = false;
                            }, err => {
                                if (err.errors) {
                                    this.msjShow({txt: 'Error', tipo: 'error', errores: err.errors});
                                }
                                this.loading = false;
                            })
                        }

                    })
            },
            limpiar() {
                for (let prop in this.a) {
                    this.a[prop] = '';
                }
                for (let prop in this.cont) {
                    this.cont[prop] = '';
                }
                this.contactos = []
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ModalCliente.vue